<template>
  <div class="d-flex flex-row-reverse mr-2">
    <v-btn
      icon
      @click="handleClick"
    >
      <v-icon>{{ icons.mdiClose }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mdiClose } from '@mdi/js'

export default {
  props: {
    handleClick: {
      type: Function,
      required: true,
    },
  },

  setup() {
    return {
      icons: {
        mdiClose,
      },
    }
  },
}
</script>
